import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ApplePayProcess = () => {
  const searchParams = useLocation().search;
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    params.set('orderType', 'order');
    navigate({
      pathname: '/applepay/screen',
      search: `?${params.toString()}`,
    });
  }, []);

  return <>In Process...</>;
};

export default ApplePayProcess;
